<template>
  <div>
    <div class="printBtnBox">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <div id="print" class="printContent" :contentLoading="contentLoading">
      <div v-for="(print, index) in printList" :key="index" class="printItem">
        <table cellpadding="0" cellspacing="0">
          <!-- header: 公司名称(左，占4列) | 空白2列 | 二维码(右，占2列，跨2行) -->
          <tr>
            <td colspan="6" style="font-weight: 700; font-size: 15pt;height: 95px; " align="center">{{print.purchaseUnit}}{{isBack ? '退货单' : '送货清单'}}</td>
            <td colspan="2" rowspan="2" style="width: 130px; text-align: right; vertical-align: middle;">
              <div :id="'qrCode' + print.billNo" align="center"/>
            </td>
          </tr>
          <!-- 出库日期和物流方式与标题等宽（合计4列），中间保留2列空白，二维码占右侧两列并跨两行 -->
          <tr>
            <td align="center" colspan="1">出库日期：</td>
            <td align="center" colspan="1" class="font-number">{{print.deliveryDate || ''}}</td>
            <td align="center" colspan="2">物流方式：</td>
            <td align="center" colspan="2" style="border-right: 1px solid #000 ">{{print.logisticsMethod || ''}}</td>
          </tr>
          <!-- 收货单位与发货编号占据整行 -->
          <tr>
            <td align="center" colspan="1">收货单位：</td>
            <td align="center" colspan="3">{{print.finalCustomerName || ''}}</td>
            <td align="center" colspan="2">发货编码：</td>
            <td align="center" colspan="2" style="font-weight: bold;" class="font-number">{{print.billNo || ''}}</td>
          </tr>
          <tr>
            <td align="center" colspan="1">收货地址：</td>
            <td align="center" colspan="7">{{print.finalCustomerAddress || ''}}</td>
          </tr>
          <!-- (备注 将放到每行最后一列) -->
          <tr>
            <td align="center" style="width:110px">序号</td>
            <td>产品名称</td>
            <td>规格型号</td>
            <td align="center">数量</td>
            <td align="center">单位</td>
            <td align="center">客户物料编码</td>
            <td align="center">仓库</td>
            <td align="center">备注</td>
          </tr>
  
          <tr v-for="(item, idx) in print.detailAppVOS" :key="item.pkId || idx" class="print-row">
            <td align="center" class="font-number">{{idx + 1}}</td>
            <td>{{item.sapProductName || ''}}</td>
            <td class="font-number">{{item.manufacturerModel || ''}}</td>
            <td align="center" class="font-number">{{item.quantity}}</td>
            <td align="center" class="font-number">{{item.unit || ''}}</td>
            <td align="center" class="font-number">{{item.customerMaterialNo || ''}}</td>
            <td align="center" class="font-number">{{constant.locationNo[item.location]}}</td>
            <td align="left">{{item.note || ''}}</td>
          </tr>
  
          <tr class="total-row">
            <td colspan="3" align="right">合计：</td>
            <td align="center" style="font-size: 18px;" class="font-number">{{totalQuantity(print)}}</td>
            <td colspan="4"/>
          </tr>
  
          <tr>
            <td colspan="1" align="center">收货人签章：</td>
            <td colspan="3">{{''}}</td>
            <td colspan="2" align="center">制单：</td>
            <td colspan="2" align="center">{{print.creatorName || ''}}</td>
          </tr>

          <tr>
            <td align="center">附注</td>
            <td colspan="7">
              <div style="font-size: 9pt;">感谢贵司大力支持，现据贵司需求发货，烦请收货后，请先检查外包装有无破损，并依据送货清单上明细与收到的箱内实物进行比对校验。并请签字后交予我方送货人员至我司。如未能收到贵司回单，我司将视贵司已确认收货。如有任何疑问请于两个工作日与我司相关人员反映！！！</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

  <script>
  import QRCode from "qrcodejs2";
  import constant from "@/util/constant";

  export default {
    data() {
      return {
        ids: [],
        contentLoading: false,
        printList: [],
        deliveryData: {},
        constant,
      };
    },

    computed: {
      isBack() {
        // 路由中是否包含Back
        return this.$route.path.includes("deliveryBack");
      },
    },

    created() {
      this.getData(JSON.parse(this.$route.query.params));
    },

    methods: {
      getData(rows) {
        this.ids = rows.map(row => row.pkId); // 这是数组了
        if (!this.ids || this.ids.length === 0) return;
        this.contentLoading = true;
        this.ids.forEach(id => {
          this.$http.get("basic", `sapDeliveryBills/getById/${id}`).then((resp) => {
            this.printList.push(resp.data || {});
            this.$nextTick(() => {
              const el = document.getElementById("qrCode" + resp.data.billNo);
              if (el) {
                el.innerHTML = "";
                this.bindQRCode(resp.data.billNo);
              }
            });
          });
        })
          .finally(() => {
            this.contentLoading = false;
          });
      },

      bindQRCode(code) {
        new QRCode(document.getElementById("qrCode" + code), {
          text: code,
          width: 110,
          height: 110,
          colorDark: "#000000", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      totalQuantity(deliveryData) {
        if (!deliveryData || !deliveryData.detailAppVOS) return 0;
        return deliveryData.detailAppVOS.reduce((sum, it) => {
          const v = parseFloat(it.quantity);
          return sum + (isNaN(v) ? 0 : v);
        }, 0);
      },

      printHandle() {
        document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
        window.print();
        // 更新发货单的打印状态
        this.$http
          .post("basic","sapDeliveryBills/updatePrintStatus",this.ids)
          .finally(()=>{
            // 通知父窗口打印完成，更新列表数据
            if (window.opener) {
              window.opener.postMessage({ type: "DELIVERY_BILL_PRINT_COMPLETED" }, "*");
            }
            window.close();
          });
      },
    },
  };
  </script>

  <style lang="scss" scoped>
    .printBtnBox {
      width: 195mm; margin: 0 auto; padding: 2mm 0; position: fixed; top: 0; left: -10cm; margin-left: 50%;background-color: #fff;z-index: 999;
    }
  .printItem {
    width: 195mm;
    border: 1px solid #000;
    font-size: 11pt;
    margin: 10px auto;
    color: #000;
    font-weight: 500;
    font-family: 'SimSun', '宋体';
    line-height: 1.2;
    word-break: break-all;
    .font-number{
      font-family: 'Courier New', monospace;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #000;
      tr {
        td {
          border-bottom: 1px solid #000;
          border-right: 1px solid #000;
          padding: 1px;
          min-width: 40px;
          vertical-align: middle;
          &:last-child {
            border-right: none;
          }
        }
        &:last-child td {
          border-bottom: none;
        }
      }
      .print-row {
        td{
          font-size: 10pt;
          font-weight: bold;
        }
      }
    }

    .signature-row {
      display: flex;
      justify-content: space-between;
      padding-top: 8px;
      div {
        width: 23%;
        text-align: left;
      }
    }
  }
  .printContent {
    padding-top: 50px;
  }

  @media print {
   /* 隐藏页码和页眉页脚 */
    @page {
      header: none;
      footer: none;
    }
     .printItem {
      margin: 0;
      page-break-inside: avoid; // 避免在打印项内部分页
    }
    // 只在打印项之间添加分页符，而不是在最后一个打印项之后
    .printItem:not(:last-child) {
      page-break-after: always;
    }
    .printBtnBox{
      display: none;
    }
    .printContent {
      padding-top: 0;
    }
  }
  </style>
